import { 
    getRecommandTenantList
    } from "@/apis/landlord/recommandTenant.js"; 
/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_checkbox_status: 'recommandTenant/set_checkbox_status',
    set_recommand_tenant: 'recommandTenant/set_recommand_tenant',
    set_selected_house: 'recommandTenant/set_selected_house',
    set_instead_loadlord_id: 'recommandTenant/set_instead_loadlord_id',
    set_instead_group_id: 'recommandTenant/set_instead_group_id',
    set_instead_sales_id: 'recommandTenant/set_instead_sales_id',
    set_filter_query: 'recommandTenant/set_filter_query',
    set_success_list: 'recommandTenant/set_success_list',
    set_org_group_list: 'recommandTenant/set_org_group_list',
    set_member_by_group: 'recommandTenant/set_member_by_group',
}

// count state 必須是 Object
const state = {
    recommandTenantList: [],
    checkboxStatus: {
        checkboxAll: false,
    },
    selectedHouse: [],
    insteadLandlordId: null,
    insteadGroupAndSales: {
        groupId: null,
        agentId: null
    },
    filterQuery: {},
    filterQueryUpdate: 0,
    successList: [],
    organizationGroupList: [],
    memberByGroupList: [],
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_RECOMMAND_TENANT_LIST: (state) => {
        return state.recommandTenantList
    },
    GET_RECOMMAND_TENANT_SUCCESS_LIST: (state) => {
        return state.successList
    },
    GET_RECOMMAND_TENANT_LIST_TOTAL: (state) => {
        return state.recommandTenantList.length
    },
    GET_RECOMMAND_TENANT_CHECKBOX_STATUS: (state) => {
        return state.checkboxStatus
    },
    GET_RECOMMAND_TENANT_HAS_SELECTED_HOUSE: (state) => {
        return state.selectedHouse.length?true:false
    },
    GET_RECOMMAND_TENANT_SELECTED_HOUSE_CID: (state) => {
        return state.selectedHouse
    },
    GET_RECOMMAND_TENANT_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_RECOMMAND_TENANT_FILTER_QUERY_UPDATE: (state) => {
        return state.filterQueryUpdate
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getRecommandTenantList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            getRecommandTenantList(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let batchDispatch = res.data.result
                    commit(types.set_recommand_tenant, batchDispatch)
                    commit(types.set_success_list)
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setRecommandTenantCheckboxStatus ( {commit}, data ) {
        commit(types.set_checkbox_status, data)
    },
    setRecommandTenantSeletedHouse ( {commit}, data ) {
        commit(types.set_selected_house, data)
    },
    setRecommandTenantFilterQuery ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_checkbox_status](state, data){
        state.checkboxStatus = data
    },
    [types.set_selected_house](state, data){
        state.selectedHouse = data
    },
    [types.set_recommand_tenant](state, data){
        state.recommandTenantList = data
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
        state.filterQueryUpdate += 1
    },
    [types.set_success_list](state, data){
        if(data){
            state.successList = data
        }else{
            state.successList = state.selectedHouse
        }
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/landlord/recommandTenant.js